// extracted by mini-css-extract-plugin
var _1 = "#4c4c4c";
var _2 = "controls_cashoutwrapper__ojijs";
var _3 = "controls_content__pax76";
var _4 = "controls_controldot__xdkvb";
var _5 = "640px";
var _6 = "790px";
var _7 = "#057676";
var _8 = "controls_full__ihtbk";
var _9 = "#434343";
var _a = "controls_item__n4drn";
var _b = "controls_itemlabel__sct52";
var _c = "controls_line__d-amw";
var _d = "controls_mask__hkqun";
var _e = "79px";
var _f = "110px";
var _10 = "72px";
var _11 = "665px";
var _12 = "controls_optional__oporv";
var _13 = "teal";
var _14 = "controls_timelinecontent__jave2";
var _15 = "2";
var _16 = "#cdd3dc";
var _17 = "controls_wrapper__memop";
export { _1 as "body", _2 as "cashOutWrapper", _3 as "content", _4 as "controlDot", _5 as "controlsMobileWidth", _6 as "controlsStackedWidth", _7 as "darkTeal", _8 as "full", _9 as "headline", _a as "item", _b as "itemLabel", _c as "line", _d as "mask", _e as "menuHeight", _f as "menuHeightLarge", _10 as "menuHeightMobile", _11 as "modalMobileWidth", _12 as "optional", _13 as "teal", _14 as "timelineContent", _15 as "timelineStrokeWidth", _16 as "timelineTrackColor", _17 as "wrapper" }
